import { JSX } from 'react';
import classNames from 'classnames';
import classes from './SwitchButton.module.scss';

interface IProps {
    checked: boolean;
    onChange(checked: boolean): void;
    id: string;
    className?: string;
    dataQa?: string;
    disabled?: boolean;
}

export const SwitchButton = (props: IProps): JSX.Element => (
    <div
        data-qa={`${props.dataQa}-button`}
        className={classNames(classes.checkbox, props.className)}
    >
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor={props.id} className={classes.checkboxLabel}>
            <input
                data-qa={`${props.dataQa}-checkbox`}
                className={classes.input}
                id={props.id}
                type="checkbox"
                checked={props.checked}
                disabled={props.disabled}
                onChange={() => {
                    props.onChange(!props.checked);
                }}
            />
            <span className={classNames(classes.icon, { [classes.disabled]: props.disabled })} />
        </label>
    </div>
);
